import toInteger from 'lodash/toInteger';
import { IDragData } from '@meitu/saas-editor-core/es/version-types';
import { editor } from '@/instance';

const getFinalSize = (naturalWidth: number, naturalHeight: number, stageWidth: number, stageHeight: number) => {
    let width = naturalWidth;
    let height = naturalHeight;

    const stageRatio = stageWidth / stageHeight;
    const ratio = naturalWidth / naturalHeight;

    if (stageRatio > ratio) {
        height = toInteger(stageHeight / 2);
        width = toInteger(naturalWidth / (naturalHeight / height));
    } else {
        width = toInteger(stageWidth / 2);
        height = toInteger(naturalHeight / (naturalWidth / width));
    }

    return {
        width,
        height,
    };
};

export const useDragLayer = () => {
    return {
        init(dragData: IDragData, target: React.MouseEvent<HTMLElement, MouseEvent>) {
            target.stopPropagation();
            const { naturalWidth, naturalHeight } = dragData;
            const { width: stageWidth, height: stageHeight } = editor.services.frame.getSize();
            const scale = editor.getScale();

            let ghost: HTMLDivElement | null = null;
            const img = target.currentTarget.querySelector('.mt-drag-item') as HTMLImageElement;

            if (img) {
                const cloneImage = img.cloneNode(true);
                const rect = img.getBoundingClientRect();
                // 创建一个漂浮的元素
                ghost = document.createElement('div');
                ghost.id = 'mt-drag-ghost';
                ghost.classList.add('mt-drag-ghost');
                ghost.appendChild(cloneImage);
                ghost.style.width = `${rect.width}px`;
                ghost.style.height = `${rect.height}px`;
                ghost.style.left = `${rect.left}px`;
                ghost.style.top = `${rect.top}px`;
                ghost.style.opacity = '0.6';
                document.body.appendChild(ghost);
                const { width, height } = getFinalSize(
                    naturalWidth || rect.width,
                    naturalHeight || rect.height,
                    stageWidth,
                    stageHeight,
                );

                if (width && height) {
                    ghost.dataset.maxWidth = `${toInteger(width * scale)}`;
                    ghost.dataset.maxHeight = `${toInteger(height * scale)}`;
                }
            }
            editor.dragLayer.setDragData(dragData);
            editor.services.frame.delActiveLayer();
        },
        destroy() {
            const ghost = document.getElementById('mt-drag-ghost');
            if (ghost) {
                document.body.removeChild(ghost);
            }
            editor.dragLayer.setDragData(null);
        },
    };
};
